import "./SearchCondition.scss";
const SearchCondition = ({ children, title = "検索条件" }) => {
  return (
    <div className="sk-search-conditions">
      <label className="sk-search-conditions--title">{title}</label>
      <div className="sk-search-conditions--items">{children}</div>
    </div>
  );
};

export default SearchCondition;
